if (!customElements.get('little-ish-mouse-society')) {
  class LittleIshMouseSociety extends HTMLElement {
    static get observedAttributes() {
      return ['data-rotate-enabled'];
    }

    connectedCallback() {
      this.circle = this.querySelector('[data-rotating-image]');
      this.updateRotation();
    }

    attributeChangedCallback() {
      this.updateRotation();
    }

    updateRotation() {
      if (!this.circle) return;

      const shouldRotate = this.dataset.rotateEnabled === 'true';
      this.circle.classList.toggle('is-rotating', shouldRotate);

      if (!shouldRotate) {
        this.circle.style.transform = 'rotate(0deg)';
        return;
      }

      this.circle.style.removeProperty('transform');
    }
  }

  customElements.define('little-ish-mouse-society', LittleIshMouseSociety);
}
